import { render, staticRenderFns } from "./DocumentsEmployee.vue?vue&type=template&id=6ad8176c&scoped=true&"
import script from "./DocumentsEmployee.vue?vue&type=script&lang=js&"
export * from "./DocumentsEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsEmployee.vue?vue&type=style&index=0&id=6ad8176c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad8176c",
  null
  
)

export default component.exports